import { useState, useRef } from "react";
import { useAppAuth } from "@/hooks/useAppAuth";
import AdminSidebar from "./AdminSidebar";
import MemberSidebar, { MemberSidebarRef } from "./MemberSidebar";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useAdminMode } from "../../contexts/AdminModeContext";
import { useColor } from "@/contexts/ColorContext";
import { appConfig } from "@/appConfig";

const Sidebar = () => {
  const { role } = useAppAuth();
  const { adminMode } = useAdminMode();

  // For admin/superadmin users, choose sidebar based on mode
  // For member users, always use MemberSidebar
  const isAdminMode = (role === "admin" || role === "superadmin") && adminMode === "admin";
  const memberSidebarRef = useRef<MemberSidebarRef>(null);
  const [collapsed, setCollapsed] = useState(false);
  const { themeColor } = useColor();

  return (
    <>
      {/* Mobile: Render sidebar directly without container */}
      <div className="lg:hidden">
        {isAdminMode ? (
          <AdminSidebar collapsed={collapsed} />
        ) : (
          <MemberSidebar ref={memberSidebarRef} collapsed={collapsed} />
        )}
      </div>

      {/* Desktop: Render with container */}
      <aside
        className={`hidden lg:block ${
          collapsed ? "w-[80px]" : "w-[300px]"
        } h-screen bg-white rounded-[24px] border border-slate-300 shadow-[0px_17px_40px_4px_#7090b01c]
          flex flex-col justify-between pb-4 overflow-hidden transition-all duration-300 ease-in-out`}
      >
        <div className="flex flex-col h-full">
          <div className="flex-1 overflow-hidden">
            {!collapsed &&
              (isAdminMode ? (
                <AdminSidebar collapsed={collapsed} />
              ) : (
                <MemberSidebar ref={memberSidebarRef} collapsed={collapsed} />
              ))}
          </div>

          {/* Collapse Button */}
          <div className="px-4 flex justify-end border-t border-gray-200 pt-2 mt-auto">
            <button
              onClick={() => setCollapsed(!collapsed)}
              className={`text-white p-3 rounded-full transition-all duration-300 ease-in-out`}
              style={
                appConfig.features.isDemoMode
                  ? { backgroundColor: themeColor }
                  : { backgroundColor: appConfig.themeColor }
              }
            >
              {collapsed ? <FaChevronRight /> : <FaChevronLeft />}
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
